export default __webpack_public_path__ + "static/media/Page_39.dcd34d19.png";